import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase } from '@/components/a-interfaz/a-controlador';
import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
import { isNumber, isString } from 'util';
import { Utiles } from '@/__env/pluggins/event-bus';
import router from '@/__env/router.index';
import { Articulo } from '@/__env/lib/Articulos';

export class ControladorInterfaz extends ControladorBase
{
    constructor()
    {
        super();
        this.Vista.Titulo = 'Ventas';
        this.Vista.Opciones.push(
            { Tipo: 'opcion', Icono: 'view-list', Modo: 'resumen', Titulo: 'Resumen' },
            { Tipo: 'opcion', Icono: 'package', Modo: 'imagenes', Titulo: 'Imagenes' },
        );
    }

    public Publicacion: Publicacion;
    public Articulo: Articulo;
    async Iniciar( ped: Publicacion | string )
    {
        this.Publicacion = null;
        this.Vista.Modo = '';
        this.Vista.Estado = 'cargando';
        if ( ped instanceof Publicacion )
        {
            this.Publicacion = ped;
        } else if ( isString( ped ) )
        {
            this.Publicacion = await Publicacion.create( ped );
        }

        if ( !this.Publicacion || !this.Publicacion.Existe )
        {
            Utiles.Notificaciones.Error( '¡Publicacion no existe!' );
            router.replace( '/mercadolibre/publicaciones' );
            return;
        }
        this.Vista.Titulo = 'Publicacion ' + this.Publicacion.Id;
        await this.Publicacion.CargarDescripcion();

        this.Articulo = null;
        if ( this.Publicacion.Codigo )
            this.Articulo = await Articulo.create( this.Publicacion.Codigo );

        this.Vista.Modo = 'resumen';
        this.Vista.Estado = 'iniciado';

    }

    async RecargarDescripcion()
    {
        await this.Publicacion.CargarDescripcion();
        this._onRecargarDescripcion.dispatch();
    }

    async Recargar()
    {
        await this.Iniciar( this.Publicacion.Id);
    }

    private _onRecargarDescripcion = new SignalDispatcher();
    public get onRecargarDescripcion() { return this._onRecargarDescripcion.asEvent(); }
}

export const Controlador = new ControladorInterfaz();


